import { Flex } from "@mantine/core";

import { useCompanyOptions } from "../../api/hooks/customer/useCompanyOptions.ts";
import Layout from "../../components/Layout/Layout";
import Title from "../../components/Title/Title";
import NewRRAnalysisTable from "./NewRRAnalysis/NewRRAnalysisTable.tsx";
import OngoingCCTable from "./OngoingCC/OngoingCCTable.tsx";
import OngoingOLTable from "./OngoingOL/OngoingOLTable.tsx";

const RiskMonitoringPage = () => {
  const [{ data: companiesData }] = useCompanyOptions();
  const companies = companiesData?.customers.data;

  return (
    <Layout>
      <Flex direction="column" gap={{ base: 16, sm: 24 }}>
        <Title>Risk Monitoring</Title>
        <NewRRAnalysisTable companies={companies} />
        <OngoingCCTable companies={companies} />
        <OngoingOLTable companies={companies} />
      </Flex>
    </Layout>
  );
};

export default RiskMonitoringPage;
